import React from 'react';

import {FaLinkedinIn, FaTwitter, } from 'react-icons/fa';
import {BsBoxArrowUpRight} from 'react-icons/bs';

function Footer() {

    return (
        <div className="footer">
            <div className="footer-text">
            <h4> 
                CONTACT <img src='/home/unicorn-logo-05.png' alt="logo" width="40 rem" style={{verticalAlign:'middle', marginLeft:'0rem'}} />  
            </h4>
            </div>
        <div className="footer-wrapper">
          <div className="footer-text" style={{width:'50%'}}>
            <p> Questions? Reach out to healthengine.berkeley@gmail.com </p>
          </div>
            
            <div className="footer-links-wrapper" style={{width:'50%'}}>

                <a href="https://www.linkedin.com/company/79873840/ " className="footer-link-text" rel="noreferrer" target="_blank"> <FaLinkedinIn/>  </a>
                <a href="https://twitter.com/healthenginecal" className="footer-link-text" rel="noreferrer" target="_blank"> <FaTwitter/> </a>
                <a href="https://phoenix.berkeley.edu" className="footer-link-text" rel="noreferrer" target="_blank">Phoenix Consulting Group <BsBoxArrowUpRight/> </a>

            </div>
            </div>
          </div>
  );

} export default Footer;